import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
// import tableVodCatalog from './tableVodTemplateCatalog';

export default {
  title: 'Ingest Main configuration',
  attributeName: 'liveIngestSetup',
  fields: [
    {
      attributeName: 'masterIngestName',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Name of the master ingest',
      label: 'Master Ingest Name',
      required: true,
      helpText: 'The name of the master Ingest Server. There must always be one and only one master.',
      errorText: '',
    },
    {
      attributeName: 'startDelay',
      label: 'Start delay',
      helpText: 'In seconds. How long the ingest processes will wait before starting the ingest. The master Ingest Server needs to purge the Live Backend, so the ingest cannot start before it has finished. There is currently no system in place to check, so the delay must be long enough.',
      default: '10',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      enabledWhen:{"field":"status_ingest","values":["not_connected","stopped","forced_stop"]},
    },
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR,
    },
    {
      attributeName: 'recordingEnabled',
      type: FormInputTypes.CHECKBOX,
      placeholder: 'Recording enabled',
      label: 'Ingest recording',
      required: true,
      helpText: 'Enables the local recording capability of the Ingest Servers.',
      errorText: '',
      enabledWhen:{"field":"status_ingest","values":["not_connected","stopped","forced_stop"]},
      visibleWhen:{"field":"deploymentType","value":"ott"},

    },
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR,
    },
    
    {
      attributeName: 'cloudRecordingEnabled',
      type: FormInputTypes.CHECKBOX,
      placeholder: 'Cloud Recording enabled',
      label: 'Cloud recording',
      required: true,
      helpText: 'Enables the cloud recording capability of the Ingest Servers.',
      errorText: '',
      enabledWhen:{"field":"status_ingest","values":["not_connected","stopped","forced_stop"]},
      visibleWhen:[{"field":"deploymentType","value":"ott"},{"field":"cloudEnabled","value":true}],

    },
    {
      attributeName: 'recordingBucket',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Bucket folder to be generated',
      label: 'Recording Bucket Path',
      required: true,
      helpText: 'The Path of the bucket. Format [a-zA-Z0-9/_-]',
      errorText: '',
      visibleWhen:[{"field":"cloudRecordingEnabled","value":true},{"field":"cloudEnabled","value":true}],

    },
    {
      attributeName: 'recordingName',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Here the recording name',
      label: 'Recording Name',
      required: true,
      helpText: 'Insert the recording name to be concat to the path of the bucket. Format [a-zA-Z0-9_-]',
      errorText: '',
      visibleWhen:[{"field":"cloudRecordingEnabled","value":true},{"field":"cloudEnabled","value":true}],

    },
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR,
      visibleWhen:{"field":"cloudEnabled","value":true}
    },
    {
      attributeName: 'storeLiveSessionsEnabled',
      type: FormInputTypes.CHECKBOX,
      placeholder: 'Store Live Sessions enabled',
      label: 'Store Live Sessions',
      required: true,
      helpText: 'Enables to store the live session.',
      errorText: '',
      enabledWhen:{"field":"status_ingest","values":["not_connected","stopped","forced_stop"]},
      visibleWhen:[{"field":"deploymentType","value":"ott"},{"field":"timeshift","value":true}],

    },
    {
      attributeName: 'bucket',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Bucket folder to be generated',
      label: 'Session Bucket Path',
      required: true,
      helpText: 'The Path of the bucket. Format [a-zA-Z0-9/_-]',
      errorText: '',
      visibleWhen:[{"field":"deploymentType","value":"ott"},{"field":"timeshift","value":true},{"field":"storeLiveSessionsEnabled","value":true}],

    },
    {
      attributeName: 'liveSessionName',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Here the session name',
      label: 'Live Session Name',
      required: true,
      helpText: 'Insert the session name to be concat to the path of the bucket. Format [a-zA-Z0-9_-]',
      errorText: '',
      visibleWhen:[{"field":"deploymentType","value":"ott"},{"field":"timeshift","value":true},{"field":"storeLiveSessionsEnabled","value":true}],

    },
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR
    },

  ],
};
